import { Injector } from '@angular/core';

import { createAction, props } from '@ngrx/store';

import { SheetViewActionPayload } from './model';

export const OPTION_SHEET_VIEW_ACTION_SCHEMA = '@optionSheetView';

export class OptionSheetViewActions {
    static OPEN_OPTION_SHEET_VIEW = `${OPTION_SHEET_VIEW_ACTION_SCHEMA}/OPEN_SHEET_VIEW`;
    static UPDATE_OPTION_SHEET_VIEW = `${OPTION_SHEET_VIEW_ACTION_SCHEMA}/UPDATE_SHEET_VIEW`;
    static CLOSE_OPTION_SHEET_VIEW = `${OPTION_SHEET_VIEW_ACTION_SCHEMA}/CLOSE_SHEET_VIEW`;

    static openOptionSheetView = createAction(
        OptionSheetViewActions.OPEN_OPTION_SHEET_VIEW,
        props<{ payload: SheetViewActionPayload; context: { injector: Injector | undefined } }>(),
    );
    static updateOptionSheetView = createAction(OptionSheetViewActions.UPDATE_OPTION_SHEET_VIEW, props<{ payload: SheetViewActionPayload }>());
    static closeOptionSheetView = createAction(OptionSheetViewActions.CLOSE_OPTION_SHEET_VIEW);
}
